import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Chip, Typography, useMediaQuery } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RuleItemProps as Props } from './types';

export const RuleItem = memo(({ className, rule }: Props) => {
  const isScreenWide = useMediaQuery('(min-width:1366px)');
  const isFree = rule.credit === 0;
  return (
    <Styled.Wrapper className={classnames('RuleItem', className)} sx={SX.root}>
      <Typography
        variant="body4"
        fontWeight={500}
        color="primary.800"
        noWrap={isScreenWide}
      >
        {rule.title}
      </Typography>
      <Chip
        variant="filled"
        size="small"
        color="primary"
        label={isFree ? 'Free' : ` x ${rule.credit}`}
        icon={isFree ? undefined : <Icon name="coin" size={14} />}
      />
    </Styled.Wrapper>
  );
});

RuleItem.displayName = 'RuleItem';
